/**
 * @generated SignedSource<<6d535171b73bdee7ee0513f7e0208142>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AuctionLotStatus = "DRAFT" | "OPEN" | "PAUSED" | "CLOSED" | "CANCELED" | "DELETED" | "%future added value";
export type Currency = "USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY" | "%future added value";
export type ImageVersionTypeName = "thumb" | "small" | "medium" | "large" | "zoom" | "original" | "master" | "placeholder" | "datamatics" | "transparent" | "bgProcessed" | "oldMaster" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CartNav_item$data = {
  readonly pdpURL: string | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly isSold: boolean | null;
  readonly photos: ReadonlyArray<{
    readonly versions: ReadonlyArray<{
      readonly webPath: string | null;
      readonly type: {
        readonly name: ImageVersionTypeName | null;
      } | null;
    } | null> | null;
  } | null> | null;
  readonly pricing: {
    readonly netPrice: {
      readonly amount: number | null;
      readonly currency: Currency | null;
      readonly convertedAmountList: ReadonlyArray<{
        readonly currency: Currency | null;
        readonly amount: number | null;
      } | null> | null;
    } | null;
    readonly salePrice: {
      readonly amount: number | null;
      readonly currency: Currency | null;
      readonly convertedAmountList: ReadonlyArray<{
        readonly currency: Currency | null;
        readonly amount: number | null;
      } | null> | null;
    } | null;
    readonly retailPrice: {
      readonly amount: number | null;
      readonly currency: Currency | null;
      readonly convertedAmountList: ReadonlyArray<{
        readonly currency: Currency | null;
        readonly amount: number | null;
      } | null> | null;
    } | null;
  } | null;
  readonly relevantAuctionLot: {
    readonly status: AuctionLotStatus | null;
    readonly buyItNowPrice: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly currency: Currency | null;
        readonly amount: number | null;
      } | null> | null;
    } | null;
  } | null;
  readonly relevantAuctionSolution: {
    readonly bids: {
      readonly totalResults: number | null;
    } | null;
  } | null;
  readonly " $fragmentType": "CartNav_item";
};
export type CartNav_item$key = {
  readonly " $data"?: CartNav_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CartNav_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v0/*: any*/)
  ],
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CartNav_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdpURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "kind": "LinkedField",
          "name": "versions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageVersionType",
              "kind": "LinkedField",
              "name": "type",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPricing",
      "kind": "LinkedField",
      "name": "pricing",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "netPrice",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "salePrice",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "retailPrice",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuctionLot",
      "kind": "LinkedField",
      "name": "relevantAuctionLot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "buyItNowPrice",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuctionSolution",
      "kind": "LinkedField",
      "name": "relevantAuctionSolution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AuctionBidsConnection",
          "kind": "LinkedField",
          "name": "bids",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "bab947e7c2d42533b7484c064379c6ed";

export default node;
